var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/save-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/save-2_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "save-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7391 4.8999H4.25573C2.83073 4.8999 1.66406 6.06657 1.66406 7.49157V16.9582C1.66406 18.1666 2.53073 18.6832 3.58906 18.0916L6.86406 16.2666C7.21406 16.0749 7.78073 16.0749 8.1224 16.2666L11.3974 18.0916C12.4641 18.6749 13.3307 18.1666 13.3307 16.9582V7.49157C13.3307 6.06657 12.1641 4.8999 10.7391 4.8999Z",
    fill: "#2B8C34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3329 4.25841V13.7251C18.3329 14.9334 17.4662 15.4417 16.4079 14.8584L14.7995 13.9584C14.6662 13.8834 14.5829 13.7417 14.5829 13.5917V7.49175C14.5829 5.37508 12.8579 3.65008 10.7412 3.65008H7.34954C7.04121 3.65008 6.82454 3.32508 6.96621 3.05841C7.39954 2.23341 8.26621 1.66675 9.25788 1.66675H15.7412C17.1662 1.66675 18.3329 2.83341 18.3329 4.25841Z",
    fill: "#2B8C34"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave2);
export default __webpack_public_path__ + "static/media/save-2.983e376252e3959d1751fcd21943fa8a.svg";
export { ForwardRef as ReactComponent };